module.exports = __webpack_public_path__ + "img/4_141.d786d98f.png";